/** Shared Shopify purchase state. Prices are supplied only by Liquid allocations. */
function sooidReadPurchaseOption(element) {
  if (!element) return null;
  const quantity = Number(element.dataset.qty);
  const jars = Number(element.dataset.jars);
  const minimum = Number(element.dataset.quantityMin || 1);
  const step = Number(element.dataset.quantityStep || 1);
  const maximum = element.dataset.quantityMax ? Number(element.dataset.quantityMax) : null;
  const months = Number(element.dataset.months || 0);
  const capsules = Number(element.dataset.capsules || 0);
  // Pack counts and subscription renewal periods do not override the label dose.
  const validPack = months === 0 || ([1, 3, 6, 7].includes(months) && jars === months && capsules === jars * 60);
  const validQuantity = Number.isInteger(quantity) && quantity > 0 && Number.isInteger(minimum) && minimum > 0 && Number.isInteger(step) && step > 0 && quantity >= minimum && quantity % step === 0 && (maximum === null || (Number.isInteger(maximum) && maximum >= quantity));
  let plans = [];
  try {
    const supplied = JSON.parse(element.dataset.plansJson || '[]');
    if (Array.isArray(supplied) && supplied.every(plan => plan && typeof plan.id === 'string' && /^\d+$/.test(plan.id) && typeof plan.name === 'string' && typeof plan.total === 'string' && plan.total.length > 0 && typeof plan.each === 'string' && plan.each.length > 0) && new Set(supplied.map(plan => plan.id)).size === supplied.length) plans = supplied;
  } catch { /* Invalid allocation data never becomes a purchasable plan. */ }
  return {
    variantId: element.dataset.variantId || '', quantity, jars,
    configured: element.dataset.configured === 'true' && /^\d+$/.test(element.dataset.variantId || '') && validQuantity && validPack && Number.isInteger(jars) && jars > 0 && Boolean(element.dataset.price),
    available: element.dataset.available === 'true',
    name: element.dataset.name || '', total: element.dataset.price || '', each: element.dataset.each || '', plans,
  };
}

function sooidPurchaseState(option, mode, planId) {
  if (!option?.configured) return { valid: false, message: 'This pack is not configured yet.' };
  if (!option.available) return { valid: false, message: 'This pack is currently unavailable.' };
  if (mode !== 'onetime' && mode !== 'subscribe') return { valid: false, message: 'Choose a purchase type.' };
  const plan = mode === 'subscribe' ? option.plans.find(candidate => candidate.id === planId) : null;
  if (mode === 'subscribe' && !plan) return { valid: false, message: option.plans.length ? 'Choose a delivery schedule for this pack.' : 'Subscription is not available for this pack yet. Choose one-time purchase.' };
  return { valid: true, variantId: option.variantId, quantity: option.quantity, planId: plan?.id || '', total: plan?.total || option.total, each: plan?.each || option.each, name: option.name, message: '' };
}

/* "Deliver every 2 months, 40% off" → "Ships every 2 months". Read from the plan name Shopify rendered;
   anything unexpected falls back to that name itself, never to an invented cadence. */
/* "About $1.61 a day": the per-day figure Koriderm-style buy boxes lead with. Parsed from the rendered
   money string (single-currency store), divided by jars × 20 days; hidden whenever anything is missing. */
function sooidMoneyNumber(text) {
  const cleaned = String(text || "").replace(/[^\d.,]/g, "").replace(/,(?=\d{3}(\D|$))/g, "").replace(",", ".");
  const value = Number(cleaned);
  return Number.isFinite(value) && value > 0 ? value : NaN;
}
function sooidPerDayLabel(total, jars, subscribed) {
  const days = Number(jars) * 20;
  const amount = sooidMoneyNumber(total);
  if (!days || !Number.isFinite(amount)) return "";
  const prefix = (String(total).match(/^[^\d]*/) || [""])[0].trim() || "$";
  return "About " + prefix + (amount / days).toFixed(2) + " a day" + (subscribed ? " on subscription" : "");
}
/* Offer wording. "Buy 2, get 1 free" appears only when a subscription total is exactly a whole number of
   single jars (3 jars at $118 = 2 × $59; 7 jars at $236 = 4 × $59), so the claim is true by construction;
   any other price falls back to the dollar saving against single jars. One-time packs only ever say "Save $X". */
function sooidTrimMoney(text) {
  return String(text || '').replace(/([.,])00(?=\D*$)/, '');
}
function sooidCentsLike(cents, sample) {
  const value = Number(cents);
  if (!Number.isFinite(value) || value <= 0) return '';
  const prefix = (String(sample || '').match(/^[^\d]*/) || [''])[0].trim() || '$';
  return sooidTrimMoney(prefix + (value / 100).toFixed(2));
}
/* "$39.33" → "$39": whole-dollar jar prices for the per-jar pack rows (owner's choice, 2026-10-23). */
function sooidRoundMoney(text) {
  const amount = sooidMoneyNumber(text);
  if (!Number.isFinite(amount)) return String(text || '');
  const prefix = (String(text).match(/^[^\d]*/) || [''])[0].trim() || '$';
  return prefix + Math.round(amount);
}
function sooidFreeJars(totalCents, singleCents, jars) {
  const total = Number(totalCents);
  const single = Number(singleCents);
  const count = Number(jars);
  if (!(total > 0 && single > 0 && count > 1) || total % single !== 0) return null;
  const paid = total / single;
  return paid >= 1 && paid < count ? { paid, free: count - paid } : null;
}
function sooidOfferLabel(free, saved) {
  if (free) return 'Buy ' + free.paid + ', get ' + free.free + ' free';
  return sooidMoneyNumber(saved) > 0 ? 'Save ' + sooidTrimMoney(saved) : '';
}
function sooidCadenceLabel(name) {
  const cleaned = String(name || '').replace(/,?\s*\d+%\s*off/i, '').replace(/,\s*\$[\d,]+(?:\.\d+)?(?:\s*off)?\s*$/i, '').trim();
  const match = cleaned.match(/^(?:deliver(?:y|ed|s)?|ships?|shipped)\s+(every\b.+)$/i);
  return match ? 'Ships ' + match[1] : cleaned;
}

if (typeof module !== 'undefined' && module.exports) module.exports = { sooidReadPurchaseOption, sooidPurchaseState, sooidCadenceLabel, sooidFreeJars, sooidOfferLabel, sooidCentsLike, sooidTrimMoney, sooidRoundMoney };

if (typeof customElements !== 'undefined' && !customElements.get('sooid-purchase')) {
  customElements.define('sooid-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.mode = this.dataset.defaultMode === 'subscribe' ? 'subscribe' : 'onetime';
      this.dataset.purchaseMode = this.mode;
      this.forms = [...this.querySelectorAll('[data-purchase-form]')];
      this.buttons = [...this.querySelectorAll('[data-mode]')];
      // The subscribe toggle states its saving, read from the plan names Shopify renders (never computed).
      const planPcts = [...this.querySelectorAll('[data-purchase-option]')].flatMap(el => (sooidReadPurchaseOption(el)?.plans || []).map(plan => Number(plan.name?.match(/(\d+)%\s*off/i)?.[1] || 0)));
      const maxPct = Math.max(0, ...planPcts);
      const subscribeButton = this.buttons.find(button => button.dataset.mode === 'subscribe');
      if (subscribeButton && maxPct && !this.classList.contains('sooid-choice')) subscribeButton.textContent = 'Subscribe & save up to ' + maxPct + '%';
      this.buttons.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => this.setMode(button.dataset.mode));
      });
      // Stacked rows: an "Automatic Refills" tick box stands in for the one-time/subscribe switch.
      this.refillBoxes = [...this.querySelectorAll('[data-refill-toggle]')];
      this.refillBoxes.forEach(box => {
        box.disabled = false;
        box.addEventListener('change', () => this.setMode(box.checked ? 'subscribe' : 'onetime'));
      });
      // "Or $57.97 with Subscribe & save": a one-tap switch shown under the one-time total (not with the refill tick box).
      this.querySelectorAll('[data-sub-offer]').forEach(offer => offer.addEventListener('click', () => this.setMode('subscribe')));
      this.forms.forEach(form => {
        const choices = [...form.querySelectorAll('[data-bundle]')];
        if (choices.length) {
          const enabled = choices.filter(choice => {
            const option = sooidReadPurchaseOption(choice);
            return option.configured && option.available;
          });
          this.selectChoice(form, enabled.find(choice => choice.dataset.selected === 'true') || enabled[0] || null);
        }
        form.addEventListener('change', event => {
          const choice = event.target.closest('[data-bundle]');
          if (choice) { this.selectChoice(form, choice); this.renderPlans(form); }
          this.synchronize(form);
        });
        form.addEventListener('submit', event => {
          if (!this.synchronize(form).valid) event.preventDefault();
        });
        this.renderPlans(form);
        this.synchronize(form);
      });
      this.setMode(this.mode);
      this.applyPreselect();
      this.dataset.ready = 'true';
    }

    /* Restore the quiz recommendation; Shopify allocations validate its plan before selection. */
    applyPreselect() {
      let pack = '';
      let plan = '';
      let hasHandoff = false;
      try {
        const params = new URLSearchParams(window.location.search);
        pack = params.get('pack') || '';
        plan = params.get('plan') || '';
        hasHandoff = Boolean(pack || plan);
        // Preserve explicit subscription links sent before the Shopify Subscriptions migration.
        // The allocation check below still rejects a plan belonging to a different pack.
        const replacements = {
          '696982765913': '696995938649',
          '696982602073': '696995971417',
          '696982798681': '696996004185',
        };
        plan = replacements[plan] || plan;
        if (!pack) {
          const saved = JSON.parse(window.sessionStorage.getItem('sooid:quiz-rec') || 'null');
          if (saved && typeof saved === 'object') {
            pack = String(saved.pack || '');
            hasHandoff = hasHandoff || Boolean(pack);
            // Owner, 2026-10-23: "always preselect subscription of 3 jars": a remembered pack opens on its
            // subscription like every other link; the renewal terms stay visible under the button.
          }
        }
      } catch {
        return;
      }
      if (!/^\d+$/.test(pack)) return;
      // The 6-jar pack was replaced by the 7-jar pack (2026-10-22). Links sent before then (?pack=6, with or
      // without the retired 6-jar plan) open the 7-jar pack; its own allocated plan stands in for the old one.
      const retiredSixPlans = ['696996004185', '696982798681'];
      const packChoice = jars => this.forms.map(form => form.querySelector('[data-bundle][data-jars="' + jars + '"]')).find(Boolean) || null;
      if (pack === '6' && !packChoice('6') && packChoice('7')) {
        pack = '7';
        if (retiredSixPlans.includes(plan)) plan = sooidReadPurchaseOption(packChoice('7'))?.plans?.[0]?.id || '';
      }
      let subscribe = false;
      let found = false;
      this.forms.forEach(form => {
        const choice = form.querySelector('[data-bundle][data-months="' + pack + '"], [data-bundle][data-jars="' + pack + '"]');
        if (!choice || choice.querySelector('input[type="radio"]')?.disabled) return;
        found = true;
        this.selectChoice(form, choice);
        this.renderPlans(form);
        if (/^\d+$/.test(plan) && sooidReadPurchaseOption(choice)?.plans.some(candidate => candidate.id === plan)) subscribe = true;
      });
      // Owner, 2026-10-23: always preselect the subscription. A link without a valid plan for its pack opens on
      // that pack's own first plan (Shopify's allocation), when it has one; one-time stays one tap away.
      if (!found) return;
      if (!subscribe) {
        const firstPlan = sooidReadPurchaseOption(packChoice(pack))?.plans?.[0]?.id || '';
        if (firstPlan) { plan = firstPlan; subscribe = true; }
      }
      this.setMode(subscribe ? 'subscribe' : 'onetime');
      this.forms.forEach(form => {
        const select = form.querySelector('[data-plan-select]');
        if (subscribe && select && [...select.options].some(option => option.value === plan)) select.value = plan;
        this.synchronize(form);
      });
    }

    selectedElement(form) {
      if (form.matches('[data-purchase-option]')) return form;
      return form.querySelector('[data-bundle] input:checked')?.closest('[data-bundle]') || null;
    }

    selectChoice(form, choice) {
      form.querySelectorAll('[data-bundle]').forEach(item => {
        const selected = item === choice;
        item.dataset.selected = String(selected);
        const radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = selected;
      });
    }

    setMode(mode) {
      if (!['onetime', 'subscribe'].includes(mode)) return;
      this.mode = mode;
      this.dataset.purchaseMode = mode;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mode === mode)));
      this.refillBoxes?.forEach(box => { box.checked = mode === 'subscribe'; });
      this.forms.forEach(form => { this.renderPlans(form); this.synchronize(form); });
    }

    renderPlans(form) {
      const select = form.querySelector('[data-plan-select]');
      if (!select) return;
      const selectedPlan = select.value;
      const option = sooidReadPurchaseOption(this.selectedElement(form));
      const plans = option?.plans || [];
      select.replaceChildren();
      plans.forEach(plan => select.add(new Option(plan.name, plan.id)));
      if (plans.some(plan => plan.id === selectedPlan)) select.value = selectedPlan;
      else if (plans.length === 1) select.value = plans[0].id;
      else if (selectedPlan && plans.length) {
        // Several cadences and the previous one is not offered here: a different pack must never
        // silently change renewal cadence, so the shopper chooses again.
        select.add(new Option('Choose a delivery schedule for this pack', '', true, true), 0);
      }
      if (!select.options.length) select.add(new Option('Subscription not yet available', ''));
      const subscribe = this.mode === 'subscribe';
      select.disabled = !subscribe || !option?.plans.length;
      // Each pack states its own schedule on the card; the select only appears when a pack really
      // offers several cadences and the shopper has to pick one.
      form.querySelector('[data-plans]').hidden = !subscribe || plans.length < 2;
    }

    synchronize(form) {
      const selected = this.selectedElement(form);
      const option = sooidReadPurchaseOption(selected);
      const planId = form.querySelector('[data-plan-select]')?.value || '';
      const state = sooidPurchaseState(option, this.mode, planId);
      const variantInput = form.querySelector('[data-variant-input]');
      const quantityInput = form.querySelector('[data-qty-input]');
      const planInput = form.querySelector('[data-plan-input]');
      variantInput.value = state.valid ? state.variantId : '';
      quantityInput.value = state.valid ? String(state.quantity) : '';
      variantInput.disabled = !state.valid;
      quantityInput.disabled = !state.valid;
      planInput.value = state.valid ? state.planId : '';
      planInput.disabled = !state.valid || this.mode !== 'subscribe';
      const atc = form.querySelector('[data-atc]');
      atc.disabled = !state.valid;
      atc.textContent = state.valid ? (atc.dataset.label || 'Add to cart') + (this.dataset.atcPrice === 'true' && state.total ? ' \u00b7 ' + state.total : '') : 'Unavailable';
      form.querySelector('[data-purchase-status]').textContent = state.message;
      // The card already names the cadence; the note only restates it when a pack offers several and one was chosen.
      const chosen = this.mode === 'subscribe' && state.valid ? option.plans.find(plan => plan.id === state.planId) : null;
      const single = this.querySelector('[data-purchase-option][data-jars="1"][data-configured="true"]');
      const singleCents = Number(single?.dataset.priceCents);
      const offerPlan = chosen || option?.plans?.[0];
      const offerFree = option?.configured && option.available ? sooidFreeJars(offerPlan?.totalCents, singleCents, option.jars) : null;
      const offerSaved = option?.configured && option.available && sooidMoneyNumber(offerPlan?.saving) > 0 ? sooidTrimMoney(offerPlan.saving) : '';
      const subscribeLabel = this.querySelector('[data-subscribe-label]');
      if (subscribeLabel) {
        subscribeLabel.textContent = offerFree
          ? 'Subscribe & get ' + offerFree.free + (offerFree.free === 1 ? ' jar' : ' jars') + ' free'
          : 'Subscribe & save' + (offerSaved ? ' ' + offerSaved : '');
        this.querySelector('[data-subscribe-sale]').hidden = !(offerFree || offerSaved);
      }
      // The tick box names the same offer the selected row shows with refills on: free jars when the plan
      // total is a whole number of single jars, otherwise the dollar saving against single jars.
      // No free jars (the single jar): the percentage reads stronger than a small dollar amount (owner, 2026-10-23).
      const refillPct = this.querySelector('[data-refill-pct]');
      if (refillPct) {
        const pct = Number(offerPlan?.savingPct);
        refillPct.textContent = offerFree
          ? 'Get ' + offerFree.free + ' free ' + (offerFree.free === 1 ? 'jar' : 'jars')
          : (pct > 0 ? 'Save ' + pct + '%' : (offerSaved ? 'Save ' + offerSaved : 'Save'));
      }
      const restate = chosen && option.plans.length > 1 ? 'Recurring delivery: ' + chosen.name + '. ' : '';
      form.querySelector('[data-plan-note]').textContent = restate;
      const charge = form.querySelector('[data-charge-total]');
      const terms = form.querySelector('[data-charge-terms]');
      if (charge) charge.textContent = state.valid ? state.total : '—';
      const unitPrice = form.querySelector('[data-charge-each]');
      if (unitPrice) {
        unitPrice.textContent = state.valid ? state.each : '—';
        form.querySelector('[data-charge-supply]').textContent = state.valid ? option.jars + (option.jars === 1 ? ' Jar' : ' Jars') + ' · ' + option.jars * 20 + '-day supply' : '';
        const reference = singleCents * option?.jars;
        const total = Number(chosen ? chosen.totalCents : selected?.dataset.priceCents);
        const saving = state.valid && reference > 0 && total > 0 && total < reference ? reference - total : 0;
        const free = chosen ? sooidFreeJars(total, singleCents, option?.jars) : null;
        form.querySelector('[data-unit-discount]').hidden = saving <= 0;
        form.querySelector('[data-unit-reference]').textContent = saving > 0 ? single.dataset.each : '';
        form.querySelector('[data-unit-saving]').textContent = saving > 0 ? (free ? sooidOfferLabel(free, '') : 'Save ' + sooidCentsLike(saving, single.dataset.each)) : '';
      }
      if (terms) {
        const cadence = chosen ? sooidCadenceLabel(chosen.name).replace(/^Ships /, '') : '';
        terms.textContent = !state.valid ? state.message : chosen
          ? 'Renews at ' + state.total + ' ' + cadence + ' until canceled.'
          : 'One-time purchase. No automatic renewal.';
      }
      const modeDescription = this.querySelector('[data-mode-description]');
      if (modeDescription) modeDescription.textContent = !state.valid ? state.message : chosen
        ? sooidCadenceLabel(chosen.name) + '. ' + state.each + ' per jar per delivery.'
        : 'One-time purchase. No automatic renewal.';
      const perDay = form.querySelector('[data-charge-perday]');
      if (perDay) {
        const label = state.valid ? sooidPerDayLabel(state.total, selected?.dataset.jars, Boolean(chosen)) : '';
        perDay.textContent = label;
        perDay.hidden = !label;
      }
      // In one-time mode, say what the same pack costs on subscription. Price, percentage and cadence
      // are the strings Shopify rendered for the pack's own plan; nothing is computed here.
      const subOffer = form.querySelector('[data-sub-offer]');
      if (subOffer) {
        const firstPlan = option?.plans?.[0];
        const showOffer = this.mode === 'onetime' && state.valid && Boolean(firstPlan?.total);
        subOffer.hidden = !showOffer;
        if (showOffer) {
          const offerPct = firstPlan.name?.match(/(\d+)%\s*off/i)?.[1];
          const offerCadence = sooidCadenceLabel(firstPlan.name);
          const firstFree = sooidFreeJars(firstPlan.totalCents, singleCents, option.jars);
          const freeText = firstFree ? sooidOfferLabel(firstFree, '').toLowerCase() : '';
          const details = [freeText || (offerPct ? offerPct + '% off' : ''), /^Ships every/.test(offerCadence) ? offerCadence.replace(/^Ships/, 'ships') : ''].filter(Boolean).join(', ');
          subOffer.textContent = 'Or ' + sooidTrimMoney(firstPlan.total) + ' with Subscribe & save' + (details ? ' (' + details + ')' : '') + ' →';
        } else {
          subOffer.textContent = '';
        }
      }
      const options = form.matches('[data-purchase-option]') ? [form] : [...form.querySelectorAll('[data-purchase-option]')];
      options.forEach(element => {
        const data = sooidReadPurchaseOption(element);
        const displayedPlan = data?.plans.find(plan => plan.id === planId) || data?.plans[0];
        const display = element === selected ? state : sooidPurchaseState(data, this.mode, displayedPlan?.id || '');
        // A pack that is in stock keeps showing its real Liquid-rendered price even when the purchase
        // state is incomplete (e.g. no delivery schedule chosen yet) — 'Unavailable' is reserved for
        // packs that genuinely cannot be bought. The status line does the prompting.
        const purchasable = Boolean(data?.configured && data?.available);
        const fallbackTotal = purchasable ? (displayedPlan?.total || data.total) : '';
        const fallbackEach = purchasable ? (displayedPlan?.each || data.each) : '';
        const total = element.querySelector('[data-option-total]');
        const each = element.querySelector('[data-option-each]');
        if (total) {
          const shownTotal = display.valid ? display.total : (fallbackTotal || 'Unavailable');
          total.textContent = total.hasAttribute('data-total-trim') ? sooidTrimMoney(shownTotal) : shownTotal;
        }
        // Total-first rows: strike the single-jar total only when this pack really costs less.
        const totalStrike = element.querySelector('[data-total-strike]');
        if (totalStrike && Number.isFinite(singleCents)) {
          const shownCents = Math.round(sooidMoneyNumber(display.valid ? display.total : fallbackTotal) * 100);
          totalStrike.hidden = !(shownCents > 0 && shownCents < singleCents * Number(data?.jars));
        }
        if (each) {
          const unit = each.hasAttribute('data-price-only') ? '' : ' per jar';
          const shown = display.valid ? display.each : fallbackEach;
          const round = each.hasAttribute('data-each-round');
          each.textContent = shown ? (round ? sooidRoundMoney(shown) : shown) + unit : 'Unavailable';
          // Per-jar rows strike the single-jar price only when this pack's jar really costs less.
          const strike = element.querySelector('[data-jar-strike]');
          if (strike && Number.isFinite(singleCents)) strike.hidden = !(Math.round(sooidMoneyNumber(shown)) < Math.round(singleCents / 100));
        }
        element.querySelectorAll('[data-show-mode]').forEach(item => { item.hidden = item.dataset.showMode !== this.mode; });
        // One-time nudge on the small pack: {save} = the 3-jar pack's real one-time saving, read from its row.
        element.querySelectorAll('[data-nudge-template]').forEach(item => {
          const three = this.querySelector('[data-purchase-option][data-jars="3"][data-configured="true"]');
          const save = sooidMoneyNumber(three?.dataset.packSaving) > 0 ? sooidTrimMoney(three.dataset.packSaving) : '';
          const template = item.dataset.nudgeTemplate;
          item.textContent = save ? template.replace('{save}', save) : template.replace('{save} + ', '').replace('{save}', '');
        });
        const packDiscounts = element.querySelectorAll('[data-pack-discount]');
        if (packDiscounts.length) {
          const subscribed = this.mode === 'subscribe';
          const saved = subscribed ? displayedPlan?.saving : element.dataset.packSaving;
          const free = subscribed ? sooidFreeJars(displayedPlan?.totalCents, singleCents, data?.jars) : null;
          const label = sooidOfferLabel(free, saved);
          packDiscounts.forEach(item => { item.hidden = !display.valid || !label; });
          element.querySelectorAll('[data-pack-percent]').forEach(item => { item.textContent = label; });
          element.querySelectorAll('[data-pack-saved]').forEach(item => { item.textContent = saved ? (item.dataset.format || '{amount} saved').replace('{amount}', saved) : ''; });
        }
        element.querySelectorAll('[data-onetime-only]').forEach(item => { item.hidden = this.mode !== 'onetime'; });
        // Subscribe mode shows its own saving: the one-time per-jar price struck through and the plan's
        // percentage, both read from the strings Shopify rendered — nothing computed here.
        const subPct = displayedPlan?.name?.match(/(\d+)%\s*off/i)?.[1];
        element.querySelectorAll('[data-subscribe-only]').forEach(item => { item.hidden = this.mode !== 'subscribe' || !display.valid; });
        const pctEl = element.querySelector('[data-sub-pct]');
        if (pctEl) pctEl.textContent = subPct ? subPct + '% off' : '';
        const cadence = element.querySelector('[data-plan-cadence]');
        if (cadence) {
          const showCadence = this.mode === 'subscribe' && Boolean(displayedPlan?.name);
          cadence.hidden = !showCadence;
          cadence.textContent = showCadence ? sooidCadenceLabel(displayedPlan.name) : '';
        }
        const hint = element.querySelector('[data-sub-hint]');
        if (hint) {
          // Subscription price hint comes straight from the Liquid allocation strings; nothing is computed here.
          const first = data?.plans?.[0];
          const show = this.mode === 'onetime' && display.valid && Boolean(first?.each);
          const pct = first?.name?.match(/(\d+)%\s*off/i)?.[1];
          hint.hidden = !show;
          const cadenceHint = show ? sooidCadenceLabel(first.name) : '';
          hint.textContent = show ? 'Subscribe & save: ' + first.each + ' per jar' + (pct ? ' (' + pct + '% off)' : '') + (/^Ships every/.test(cadenceHint) ? ' \u00b7 ' + cadenceHint.replace(/^Ships/, 'ships') : '') : '';
        }
      });
      const pdp = this.closest('sooid-pdp');
      if (pdp) {
        const sticky = pdp.closest('.shopify-section')?.querySelector('sooid-sticky');
        const price = sticky?.querySelector('[data-sticky-price]');
        const name = sticky?.querySelector('[data-sticky-name]');
        const button = sticky?.querySelector('[data-sticky-add]');
        // Per-jar rows (no pack totals anywhere, owner 2026-10-23): the sticky bar repeats the row's whole-dollar jar price.
        const perJar = Boolean(selected?.querySelector('[data-each-round]')) && !selected?.querySelector('[data-total-trim]');
        const jarsLabel = option && option.jars ? option.jars + (Number(option.jars) === 1 ? ' jar' : ' jars') : '';
        // Total-first rows: the sticky bar shows the row's whole-dollar total and jar price.
        const totalFirst = Boolean(selected?.querySelector('[data-total-trim]'));
        if (price) price.textContent = state.valid ? (perJar ? sooidRoundMoney(state.each) + '/jar' : totalFirst ? sooidTrimMoney(state.total) : state.total) : '';
        if (name) name.textContent = jarsLabel && state.valid && state.each ? (perJar ? jarsLabel : jarsLabel + ' \u00b7 ' + (totalFirst ? sooidRoundMoney(state.each) + '/jar' : state.each + ' per jar')) : (option?.name || 'Choose your pack');
        if (button) { button.disabled = !state.valid; button.dataset.addLabel = atc.textContent; button.textContent = atc.textContent; }
      }
      this.dispatchEvent(new CustomEvent('sooid:purchase:change', { bubbles: true, detail: { valid: state.valid, mode: this.mode, variantId: state.variantId || null, quantity: state.quantity || null, sellingPlanId: state.planId || null } }));
      return state;
    }
  });
}
